import { fetchWrapper } from "api";

export const getChains = () =>
  fetchWrapper(
    "/chain/chains" + (process.env.REACT_APP_SUB_MODE ? "?env=" + process.env.REACT_APP_SUB_MODE.toLowerCase() : "")
  );
